import React, { useContext, useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import companyIcon from '../../images/svg/companyIcon.svg'
import { CartContext } from '../../context/cart'
import { BigHead } from '@bigheads/core'

const HeaderMobile = () => {
    const { handleStateCart, cart } = useContext(CartContext)
    const [name,setName] = useState()
    const navigate = useNavigate()

    const redirectToLandingPage = () => {

        navigate("/")

    }
    const redirectToAccountPage = () => {
        if (localStorage.getItem("@USER_TOKEN")) {
            navigate("/dashboard/v2")
            return false
        }
        navigate("/account/login")
    }

    const getUserInfo = () => {
        const name = localStorage.getItem("@0e63f110-145a-451e-8f8f-3404b15220c5")

        if(name){
            const namePartts = name.split(" ")
            setName(namePartts[0])
        }

    }

    useEffect(() => {

        getUserInfo()

    },[])


    return (

        <header className='header_mobile'>

            <img src={companyIcon} onClick={() => redirectToLandingPage()} />

            <div className='container_cart'>


            {localStorage.getItem("@USER_TOKEN") 
            ?
            <div className='box_header_image_account' onClick={() => redirectToAccountPage()} >
            <div style={{ width: "64px", height: "77px", marginTop: "0rem" }}>
                {localStorage.getItem("@a951ebde-958e-4ad5-8acd-206a506ae580") 
                
                ?
                    <img className='user_image_icon' src={localStorage.getItem("@a951ebde-958e-4ad5-8acd-206a506ae580")}/>
                :
                <div style={{ width: "64px", height: "77px" }}>
                <BigHead
                    accessory="shades"
                    body="chest"
                    circleColor="blue"
                    clothing="tankTop"
                    clothingColor="black"
                    eyebrows="angry"
                    eyes="wink"
                    facialHair="mediumBeard"
                    graphic="vue"
                    hair="short" 
                    hairColor="black"
                    hat="none"
                    hatColor="green"
                    lashes="false"
                    lipColor="purple"
                    mask="true"
                    faceMask="true"
                    mouth="open"
                    skinTone="brown"
                />
            </div>
                }
         
            </div>
            <p>Olá,{name}</p>

        </div>
            :

            <div className='box_header_image_account' onClick={() => redirectToAccountPage()} >
            <div style={{ width: "64px", height: "77px", marginTop: "0rem" }}>

                <div style={{ width: "64px", height: "77px" }}>
                    <BigHead
                        accessory="shades"
                        body="chest"
                        circleColor="blue"
                        clothing="tankTop"
                        clothingColor="black"
                        eyebrows="angry"
                        eyes="wink"
                        facialHair="mediumBeard"
                        graphic="vue"
                        hair="short" 
                        hairColor="black"
                        hat="none"
                        hatColor="green"
                        lashes="false"
                        lipColor="purple"
                        mask="true"
                        faceMask="true"
                        mouth="open"
                        skinTone="brown"
                    />
                </div>
            </div>  
            <p>Entrar</p>

        </div>

            }

           
                <svg onClick={() => handleStateCart(true)} width="53" height="48" viewBox="0 0 53 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="6" width="42" height="42" rx="21" fill="black" />
                    <path d="M27.7839 28.293C27.7078 28.5723 27.4539 28.75 27.1746 28.75H19.7351L19.9128 29.5625H26.7175C27.0984 29.5625 27.4031 29.9434 27.3015 30.3242L27.1746 30.9336C27.657 31.1621 27.9871 31.6445 27.9871 32.2031C27.9871 32.9902 27.3269 33.625 26.5652 33.625C25.7781 33.625 25.1433 32.9902 25.1433 32.2031C25.1433 31.8223 25.2957 31.4668 25.5496 31.1875H20.2429C20.4968 31.4668 20.6746 31.8223 20.6746 32.2031C20.6746 32.9902 20.0144 33.625 19.2527 33.625C18.4656 33.625 17.8308 32.9902 17.8308 32.2031C17.8308 31.6953 18.1101 31.2383 18.5418 30.9844L16.739 22.25H14.9871C14.6316 22.25 14.3777 21.9961 14.3777 21.6406V21.2344C14.3777 20.9043 14.6316 20.625 14.9871 20.625H17.5769C17.8562 20.625 18.1101 20.8535 18.1863 21.1328L18.4148 22.25H28.3679C28.7742 22.25 29.0535 22.6309 28.9773 23.0117L27.7839 28.293Z" fill="white" />
                    <rect x="29.78" y="1" width="22" height="22" rx="11" fill="white" />
                    <rect x="29.78" y="1" width="22" height="22" rx="11" stroke="black" stroke-width="2" />
                </svg>



                {String(cart).length == 0

                    ?
                    <p className='number_cart'>0</p>
                    :
                    <p className='number_cart'>{cart.length}</p>

                }

            </div>

        </header>

    )
}

export default HeaderMobile